import { apiClient } from './client';

export interface UserLevelProgress {
  level: number;
  achievedAt: string;
  isBackfilled: boolean;
}

export interface UserLevels {
  currentLevel: number;
  progress: UserLevelProgress[];
  pendingCelebration: number | null;
}

export const getMyLevels = () =>
  apiClient.get<{ data: UserLevels }>('/users/me/levels');

export const acknowledgeLevel = (level: number) =>
  apiClient.patch(`/users/me/levels/${level}/acknowledge`);
